import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from "react-redux";

import ListV2 from '../content/list/ListV2';
// import RadioButton from '../../../../automix/RadioButton';

import useGetOne from '../../../hooks/useGetOne';

function ConnectedCollection({ width, height }) {
  const api = useSelector( state => state.api);
  const { item } = useGetOne(api, '/my/downloads/', null);

  return (
    <div className={`flexColumn playlist-page`}>
      <div className={`flexRow card-container-collection`}>
        <div className={`playlist-infos infos-collection flexRow space-between`}>
          <div className={'flexColumn f-center'}>
            <p className={`playlist-title type-title`}>Collection</p>
            <p className={`playlist-p type-small`}>
              {item ? item.count : 0} Tracks
            </p>  
          </div>
        </div>
      </div>
      { item && (
        <div className={`content-container`} style={{ width }} >
          {item.count > 0 ? (
            <ListV2
              pathApi={`/my/downloads/?per_page=100` /*`/my/downloads/?is_available_for_streaming=true&per_page=100`*/}
              sortable={false}
              id={`collection`}
              width={width}
              height={height - (Config.TAB_BAR_GUTTER * 5.8)}
              size={Config.LIST_ROW_HEIGHT}
              style={{/*marginTop: 27*/}}
              isLoadMore={true}
              type={`Full`}
              orderBy={[`default`] /* API - Any WORKS */}
              filters={[`track_name`, /*`mix_name`,*/ `artists_s`, `remixers_s`, `label`, `genre_s`, `bpm`, `key_convert`, `publish_date`]}
              filtersStyle={{position: `absolute`, top: 25, right: 127}}
              panelStyle={{ margin: `0px 0px 16px 0px` }}
              automix={true}
              automixName={`Collection`}
              automixStyle={{ position: `absolute`, top: 25, left: `auto`, right: 0 }}
              from={`/collection`}
            />
          ) : (
            <span className={'type-placeholder'}>Purchased tracks will appear here, ready for playback.</span>
          )}
        </div>
      )}
    </div>
  );
}

ConnectedCollection.propTypes = {
  width: PropTypes.any,
  height: PropTypes.any
}

const Collection = connect(
  state => ({
    width: state.dimension.width,
    height: state.dimension.height
  })
)(ConnectedCollection);

export default Collection;
